import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AclAccess } from '@firestitch/acl';
import { FsMessage } from '@firestitch/message';

import { AclService } from '@app/core/services';

@Injectable()
export class PermissionGuard  {
  private _aclService = inject(AclService);
  private _router = inject(Router);
  private _message = inject(FsMessage);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): true | UrlTree {
    if (!route.data.permission) {
      return true;
    }

    if (this._aclService.has(route.data.permission, route.data.access || AclAccess.Read)) {
      return true;
    }

    return this._router.createUrlTree(['/']);
  }

}
